export default class FakturaBatchCtrl {

  constructor(FakturaciaService){
    this.FakturaciaService = FakturaciaService;
    this.file = null;
    this.data = null;
    this.invoices = [];

    this.createInvoices();
  }

  onFile($file){
    this.file = $file;
  }

  readXls(){
    return this.FakturaciaService.readInputXls(this.file)
    .then(out => this.data = out);
  }

  requestPOFDUF(){
    return this.FakturaciaService.requestMissingPOFDUF();
  }

  createInvoices(){
    return this.FakturaciaService.createInvoices().then(i => this.data = this.invoices = i);
  }

  downloadInvoice(invoice){
    return this.FakturaciaService.exportXls(invoice);
  }


}


// WEBPACK FOOTER //
// ./src/Fakturacia/FakturaBatchCtrl.js